// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PurchaseOrderInvoiceLine } from './purchase-order-invoice-line';
import { Vendor } from './vendor';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PurchaseOrderInvoice extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  // get total() {
  //   let total = 0;
  //   if (this.purchaseOrderLineReceivings && this.purchaseOrderLineReceivings.length > 0) {
  //     this.purchaseOrderLineReceivings.forEach(receiving => {
  //       total += receiving.cost;
  //     });
  //   }
  //   return total;
  // }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  dueDate!: Date;
  invoiceDate!: Date;
  note?: string;
  quickBooksId?: string;
  quickBooksLastExport?: Date;
  readyToExport?: Date;
  referenceNumber?: string;
  total!: number;
  vendorId?: number;
  purchaseOrderInvoiceLines!: PurchaseOrderInvoiceLine[];
  vendor!: Vendor;
}

